import { axiosWithToken } from "@/utils/axios";
import {
  AddBusinessDocumentPayload,
  BusinessDocumentMutationResponse,
  BusinessDocumentResponse,
  BusinessDocumentsResponse,
  BusinessInfoResponse,
  EditBusinessDocumentPayload,
  UpdateBusinessInfoPayload,
} from "@/types/business";

class ServiceClass {
  getBusinessDetails() {
    return axiosWithToken().get<BusinessInfoResponse>("/business/details");
  }

  updateBusinessDetails(payload: UpdateBusinessInfoPayload) {
    return axiosWithToken().patch("/business/details", payload);
  }

  getBusinessDocuments() {
    return axiosWithToken().get<BusinessDocumentsResponse>(
      "/business/documents",
    );
  }

  getBusinessDocumentById(documentId: string) {
    return axiosWithToken().get<BusinessDocumentResponse>(
      `/business/documents/${documentId}`,
    );
  }

  addBusinessDocument(payload: AddBusinessDocumentPayload) {
    return axiosWithToken().post<BusinessDocumentMutationResponse>(
      "/business/documents",
      payload,
    );
  }

  editBusinessDocument(
    documentId: string,
    payload: EditBusinessDocumentPayload,
  ) {
    return axiosWithToken().put<BusinessDocumentMutationResponse>(
      `/business/documents/${documentId}`,
      payload,
    );
  }

  deleteBusinessDocument(documentId: string) {
    return axiosWithToken().delete(`/business/documents/${documentId}`);
  }

  submitKyc() {
    return axiosWithToken().get("/business/submit_kyc");
  }
}

const KYCService = new ServiceClass();
export default KYCService;
